// extracted by mini-css-extract-plugin
module.exports = {"dimmer":"Modal_dimmer__2JLj9","modal":"Modal_modal__1vwov"};